export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10461.5a0b37c0.jpg";